import React, { type ComponentProps } from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { Tag } from '@fourthwall/components'

import * as S from './ProductsStatusModalAccordionHeading.styled'

export type ProductsStatusModalAccordionHeadingProps = {
  imageSrc?: string
  name: string
  tag?: ComponentProps<typeof Tag>
  description: string | undefined
  url: string
  onClick?: () => void
}

export const ProductsStatusModalAccordionHeading = ({
  imageSrc,
  name,
  tag,
  description,
  url,
  onClick,
}: ProductsStatusModalAccordionHeadingProps) => (
  <S.Container onClick={onClick}>
    {imageSrc && (
      <S.ImageContainer>
        <PhotoThumbnail url={imageSrc} size="tiny" />
      </S.ImageContainer>
    )}
    <S.NameContainer>
      <S.Name href={url} target="_blank" rel="noopener noreferrer">
        {name}
      </S.Name>
    </S.NameContainer>
    {tag && (
      <div>
        <Tag {...tag} />
      </div>
    )}
    {description && <S.Description>{description}</S.Description>}
  </S.Container>
)
